import { useState, useEffect } from "react";
import Header from "./header";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../helper/ApiCall";
import { END_POINT, METHODS, BASE_URL_IMAGE } from "../../helper/helper";
import "../dashscreen/BlogCss.css";

const BlogScreen = () => {
  const navigate = useNavigate();

  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadBlogs = async () => {
    setLoading(true);
    try {
      const result = await fetchData(END_POINT.GetBlog, METHODS.GET);
      setBlogPosts(result?.success ? result.data || [] : []);
    } catch (error) {
      console.error("Blog fetch error:", error);
      setBlogPosts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBlogs();
  }, []);

  // First blog as featured
  const featuredBlog = blogPosts[0];
  const otherBlogs = blogPosts.slice(1);

  return (
    <>
      <Header />

      {/* HERO SECTION */}
      <section className="blog-hero">
        <div className="container">
          <h1>AI Insights & Tutorials</h1>
          <p>
            Stay updated with the latest AI trends, tool reviews, and practical guides
          </p>
        </div>
      </section>

      {/* FEATURED SECTION */}
      {featuredBlog && (
        <section className="featured-section">
          <div className="container">
            <h2 className="featured-label">Featured Article</h2>

            <div
              className="featured-post"
              onClick={() => navigate(`/blog-detail/${featuredBlog._id}`)}
            >
              <div className="featured-image">
                <img
                  src={`${BASE_URL_IMAGE}${featuredBlog.image}`}
                  alt={featuredBlog.title}
                />
                <div className="featured-tag">Featured</div>
              </div>

              <div className="featured-content">
                <div className="featured-meta">
                  <span className="meta-item">
                    📅 {featuredBlog.createdAt?.slice(0, 10)}
                  </span>
                </div>

                <h2 className="featured-title">
                  {featuredBlog.title}
                </h2>

                <p className="featured-excerpt">
                  {featuredBlog.desc?.replace(/<[^>]*>/g, "").slice(0, 180)}...
                </p>

                <button
                  className="read-more-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/blog-detail/${featuredBlog._id}`);
                  }}
                >
                  Read Full Article →
                </button>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* BLOG GRID */}
      <section className="blog-grid-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Latest Articles</h2>
          </div>

          {loading ? (
            <p>Loading blogs...</p>
          ) : (
            <div className="blog-grid">
              {otherBlogs.map((post) => (
                <div
                  key={post._id}
                  className="blog-card"
                  onClick={() => navigate(`/blog-detail/${post._id}`)}
                >
                  <div className="blog-image">
                    <img
                      src={`${BASE_URL_IMAGE}${post.image}`}
                      alt={post.title}
                    />
                    <div className="blog-category">
                      {post.category || "General"}
                    </div>
                  </div>

                  <div className="blog-content">
                    <div className="blog-meta">
                      <span>
                        📅 {post.createdAt?.slice(0, 10)}
                      </span>
                    </div>

                    <h3 className="blog-title">{post.title}</h3>

                    <p className="blog-excerpt">
                      {post.desc?.replace(/<[^>]*>/g, "").slice(0, 120)}...
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="newsletter-section">
  <div className="container">
    <div className="newsletter-box">
      <h2>Stay in the Loop</h2>
      <p>Get the latest AI insights delivered straight to your inbox</p>

      <form
        className="newsletter-form"
        onSubmit={(e) => {
          e.preventDefault();   // prevent page reload
          console.log("Subscribed!");
        }}
      >
        <input
          type="email"
          className="newsletter-input"
          placeholder="Enter your email"
          required
        />

        <button type="submit" className="newsletter-btn">
          Subscribe
        </button>
      </form>
    </div>
  </div>
</section>


      {/* FOOTER */}
      <footer>
        <div className="container">
          <div className="footer-content">
            <p>© 2026 AIHub. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default BlogScreen;